import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-customer-page',
    templateUrl: './common-customer-page.component.html',
    styleUrls: ['./common-customer-page.component.scss'],
    standalone: false
})
export class CommonCustomerPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
